var QueueErrorController = (function () {
    function QueueErrorController($scope, env, $filter, $timeout, $q, socket, DTS, DTOptionsBuilder, DTColumnBuilder, 
        //        private DTInstances:any,
        _, $compile, $state, $stateParams, notify, Dialog, settings, $mdDialog) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this._ = _;
        this.$compile = $compile;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.notify = notify;
        this.Dialog = Dialog;
        this.settings = settings;
        this.$mdDialog = $mdDialog;
        this.bookmark = 'bump';
        this.enableButtons = false;
        this.filterIots = [];
        this.filterImts = [];
        this.filterComboList = [];
        this.filterCurrCombo = [];
        this.filterCountries = [];
        this.filterSamplingStatus = [];
        this.filters = {
            countries: [],
            imts: [],
            iots: [],
            samplingStatus: []
        };
        this.socket.forward('validation.error.queue', this.$scope);
        this.$scope.$on('socket:validation.error.queue', function (event, data) {
            _this.enableButtons = true;
        });
        this.$scope.searchTable = function () {
            console.log($scope.tableInstance);
        };
    }
    QueueErrorController.prototype.$onInit = function () {
        this.queueLabel = 'Validation Queue';
        var that = this;
        /*        this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'getAllErroredQueues',
                        script: 'queue/queue',
                        email: this.env.user.email,
                    }
                });
        */
        this.dtColumns = this.buildColumns();
        this.dtOptions = this.DTOptionsBuilder.newOptions()
            .withOption('ajax', {
            dataSrc: function (data) {
                return data.data;
            },
            url: '/api/queue/valerror',
            type: 'POST',
            beforeSend: function (request) {
                request.setRequestHeader('Authorization', 'Bearer ' + that.env.user.token);
            },
            data: {}
        })
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withPaginationType('full_numbers');
    };
    /*
        buildColumns() {
            let titleHtml = `<input type="checkbox" ng-class="{'hide-dt-column': !vm.isMassAssignmentToggled}"
            ng-model="vm.selectAll" ng-click="vm.selectAllRowsInDataTable(vm.selectAll)" />`;
    
            let columns = [
                this.DTColumnBuilder.newColumn(null)
                    .withTitle(`<input type="checkbox" ng-class="{'hide-dt-column': !vm.isMassAssignmentToggled}"
                     ng-model="vm.selectAll" ng-click="vm.selectAllRowsInDataTable(vm.selectAll)" />`)
                    .notSortable()
                    .renderWith((data: any, type: any, full: any, meta: any) => {
                        //console.log('row data', data);
                        let obj = data._id + ',' +
                            data.INVOICEDAMOUNT + ',' +
                            data.WORKNUMBER.trim() + ',' +
                            data.WN_AMOUNT_LCL;
                        //console.log('Generated text: ', obj);
                        return `<input type="checkbox"
                                ng-class="{'hide-dt-column': !vm.isMassAssignmentToggled}"
                                ng-model="vm.checkBoxModel['${obj}']"/>`;
                    })
                    .withOption('name', 'assign-col')
                    .withOption('searchable', false),
                this.DTColumnBuilder.newColumn('CTRY_DESC').withTitle('Country'),
                this.DTColumnBuilder.newColumn('LOB').withTitle('LoB'),
                this.DTColumnBuilder.newColumn('LEGALCONNUM').withTitle('Legal Contract Number'),
                this.DTColumnBuilder.newColumn('CUST_NM').withTitle('Customer Name'),
                this.DTColumnBuilder.newColumn('WORKNUMBER').withTitle('Worknumber'),
                this.DTColumnBuilder.newColumn('PONUMBER').withTitle('PO Number'),
                this.DTColumnBuilder.newColumn('WN_AMOUNT_LCL').withTitle('Worknumber Amount'),
                this.DTColumnBuilder.newColumn('CUSTOMERCONTROL').withTitle('Customer Control').withOption('width', '15%'),
                this.DTColumnBuilder.newColumn('INVOICESTATUS').withTitle('Invoice Status').withOption('width', '15%'),
                this.DTColumnBuilder.newColumn('INVOICEDAMOUNT').withTitle('Invoice Amount')
                    .renderWith(data => {
                        return Math.round((data + 0.00001) * 100) / 100;
                    }),
                this.DTColumnBuilder.newColumn('CURRENCYID').withTitle('Currency'),
                this.DTColumnBuilder.newColumn('STARTDATE').withTitle('WN Start Date'),
                this.DTColumnBuilder.newColumn('ENDDATE').withTitle('WN End Date'),
                this.DTColumnBuilder.newColumn('INVOICENUMBER').withTitle('Invoice Number'),
                this.DTColumnBuilder.newColumn('INVOICEDATE').withTitle('Invoice Date').withOption('width', '100%')
            ];
    
            return columns;
    
        }
    
        */
    QueueErrorController.prototype.buildColumns = function () {
        var _this = this;
        var that = this;
        return [this.DTColumnBuilder.newColumn('ver').withTitle('Version')
                .withOption('name', 'ver')
                .renderWith(this.getVersionLabel)
                .notSortable(),
            this.DTColumnBuilder.newColumn('opp')
                .withTitle('OPP').renderWith(this.linkUrl),
            this.DTColumnBuilder.newColumn('svistat')
                .withTitle('MySA Status'),
            this.DTColumnBuilder.newColumn('country')
                .withTitle('Country'),
            this.DTColumnBuilder.newColumn('acnt')
                .withTitle('Account Name')
                .notSortable(),
            this.DTColumnBuilder.newColumn('bp')
                .withTitle('BP Name'),
            this.DTColumnBuilder.newColumn('acnt').withOption('name', 'acnt')
                .withTitle('Account Name'),
            this.DTColumnBuilder.newColumn('svisubmitdate')
                .withOption('name', 'svisubmitdate').withTitle('CVR Submit Date')
                .renderWith(function (data) {
                //return this.$filter('date')(new Date(parseInt(data, 10)), 'yyyy/MM/dd');
                if (data === null || data === 0) {
                    return 'N/A';
                }
                else {
                    return _this.$filter('date')(new Date(data), 'yyyy/MM/dd');
                }
            }),
            this.DTColumnBuilder.newColumn('decisiondate').withOption('name', 'decisiondate')
                .withTitle('Decision Date').renderWith(function (data) {
                //return this.$filter('date')(new Date(data.replace(/ /g, 'T')), 'yyyy/MM/dd');
                if (data === null || data === 0) {
                    return 'N/A';
                }
                else {
                    return _this.$filter('date')(new Date(data), 'yyyy/MM/dd');
                }
            }),
            this.DTColumnBuilder.newColumn('status').withTitle('Status'),
            this.DTColumnBuilder.newColumn('substatus')
                .withTitle('Sub Status'),
            this.DTColumnBuilder.newColumn('errQty')
                .withTitle('Error QTY'),
            this.DTColumnBuilder.newColumn('errorStat')
                .withTitle('Action').renderWith(this.resultHtml),
        ];
    };
    QueueErrorController.prototype.linkUrl = function (data, type, full, meta) {
        return '<a class="ibm-ind-link" href="detail/' + data + '/validation" ng-click="$event.preventDefault();vm.edit(' + meta.row + ')">' + data + '</a>';
    };
    QueueErrorController.prototype.resultHtml = function (data, type, full, meta) {
        if (data === 'Reject') {
            return "<p>" + data + "</p>\n                    <span>\n                        <md-icon class=\"expand\" md-svg-icon=\"expand\"></md-icon>\n                    </span>\n                    ";
        }
        else {
            return "<p>" + data + "</p> \n                    <md-icon class=\"yellow_icon\" md-svg-src=\"/public/images/ic_error_white_24px.svg\"></md-icon>";
        }
    };
    //                    <md-icon md-svg-icon="delete"></md-icon>
    //<md-icon class ="green_icon" md-svg-src="/public/images/ic_done_all_black_36px.svg" title="More than 15 days"> </md-icon>
    QueueErrorController.prototype.edit = function (index) {
        var rowData = this.dtInstance.DataTable.row(index).data();
        if (rowData.substatus === 'Unassigned') {
            this.$state.go('preview', {
                id: rowData.opp
            });
        }
        else {
            this.$state.go('detail.validation', {
                id: rowData.opp
            });
        }
    };
    QueueErrorController.prototype.getVersionLabel = function (ver) {
        switch (ver) {
            case 1:
            case 2:
                return 'CVR';
            case 3:
                return 'SWDR';
            default:
                return '';
        }
    };
    QueueErrorController.$inject = [
        '$scope', 'env', '$filter', '$timeout', '$q', 'socket',
        'DTS', 'DTOptionsBuilder', 'DTColumnBuilder', '_',
        '$compile', '$state', '$stateParams', 'notify', 'Dialog', 'settings', '$mdDialog'
    ];
    return QueueErrorController;
}());
var QueueErrorComponent = (function () {
    function QueueErrorComponent() {
        this.templateUrl = 'queueerror.html';
        this.controllerAs = 'vm';
        this.controller = QueueErrorController;
    }
    return QueueErrorComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('expand', '/public/icons/ic_expand_more_black_18px.svg');
})
    .component('queueErrorSection', new QueueErrorComponent());

//# sourceMappingURL=queue.error.component.js.map
